import {DataObject} from "./dataObject";
import {SpielPartie} from "./spielPartie";
import TimeStamp from "../timeStamp";
import store from "../../store/store";
import {db} from "../../services/db"
import SpielService from "./spielService";

export class Spiel extends DataObject {
    constructor(anzahlSpieler, anzahlErsatzSpieler, eintauschVorEinspielzeit, freieSpieler, isCup) {
        super();
        this.id = '';
        this.saison = {
            id: '',
            semester: '',
            runde: '',
            rundeText: '',
            lvId: '',
            freieSpieler: freieSpieler,
            isCup: isCup !== undefined ? isCup : false
        };
        this.heim = {
            captain: '',
            teamName: '',
            teamId: '',
            vereinsNr: '',
            vereinsName: '',
            ersatzSpieler: {},
            result: {
                schnitt: 0,
                kegel: 0,
                tabPkt: 0,
                sp: 0,
                mlp: 0,
                mp: 0,
                fw: 0,
                oeR: false,
                bR: false,
                mR: false,
            },
            protest: false,
        };
        this.gast = {
            captain: '',
            teamName: '',
            teamId: '',
            vereinsNr: '',
            vereinsName: '',
            ersatzSpieler: {},
            result: {
                schnitt: 0,
                kegel: 0,
                tabPkt: 0,
                sp: 0,
                mlp: 0,
                mp: 0,
                fw: 0,
                oeR: false,
                bR: false,
                mR: false,
            },
            protest: false,
        };
        this.referee = {
            lvId: '',
            nr: '',
            name: '',
        };
        this.infos = {
            wochentag: 'Sa',
            datum: '',
            uhrzeit: '',
            ort: '',
            bahn: '',
            kommentar: '',
            kommentarStrafe: '',
            stream: '',
        };
        this.vereine = {
            heim: '',   // pending  created     confirmed
            gast: '',   // ''       waiting     confirmed/rejected
            alle: [],   //                      [heimId, gastId]
            confirmedHeim: null,
            confirmedGast: null,
            confirmedHeimBy: '',
            confirmedGastBy: '',
            //autoConfirmed: false,
        };
        if ( isCup ) {
            this.heim.result.ar = 0;
            this.gast.result.ar = 0;
            this.heim.result.cupLeader = false;
            this.gast.result.cupLeader = false;
            this.admin = ''
        }
        // map for status of spiel, contains following fields
        this.partien = {};
        if ( anzahlSpieler ) {
            for ( let i = 1; i <= anzahlSpieler; i++ ) {
                this.partien[i] = new SpielPartie(freieSpieler, isCup);
            }
        }
        if ( this.saison.freieSpieler ) {
            this.saison.datenschutz = false;
        }
        //this.setDefaultBahnen(1);
        if ( anzahlErsatzSpieler ) {
            let ersatzSpielerObjekt = this.getEmptyErsatzspielerObjekt(eintauschVorEinspielzeit, false);
            for ( let i = 1; i <= anzahlErsatzSpieler; i++ ) {
                this.heim.ersatzSpieler[i] = ersatzSpielerObjekt;
                this.gast.ersatzSpieler[i] = ersatzSpielerObjekt;
            }
        }
        this.local.definitions.databaseHandlerCall = 'spiel';
        //this.local.tableDefs = {}
    }

    getEmptyErsatzspielerObjekt(eintauschVorEinspielzeit, frei){
        let ersatzSpielerObjekt = eintauschVorEinspielzeit ?
            {
                id: '', name: '', nationalitaet: '', eintauschVorFuer: '', eintauschFuer: '', abWurf: 0
            } : {
                id: '', name: '', nationalitaet: '', eintauschFuer: '', abWurf: 0
            };
        if ( this.saison.freieSpieler ) {
            ersatzSpielerObjekt.frei = frei;
            ersatzSpielerObjekt.hatPass = false;
        }
        return ersatzSpielerObjekt;
    }

    setVereineFromMannschaften(mannschaften) {
        let verein = mannschaften.find(team => team.id === this.gast.teamId);
        this.gast.teamName = verein.name;
        this.gast.vereinsNr = verein.lvId + verein.vereinsNr;
        this.gast.vereinsName = verein.vereinsName;
        verein = mannschaften.find(team => team.id === this.heim.teamId);
        this.heim.teamName = verein.name;
        this.heim.vereinsNr = verein.lvId + verein.vereinsNr;
        this.heim.vereinsName= verein.vereinsName;
    }

    setPending(){
        this.vereine.heim = this.heim.vereinsNr + '_pending';
        this.vereine.gast = '';
        this.vereine.alle = [];
    }

    setDefaultBahnen (ersteBahn) {
        const addBahnen = ersteBahn - 1;
        Object.keys(this.partien).forEach( (partieId) => {
            this.setDefaultBahnenHeimGast(partieId, 'heim', addBahnen);
            this.setDefaultBahnenHeimGast(partieId, 'gast', addBahnen);
        });
    }
        setDefaultBahnenHeimGast(partieId, teamType, addBahnen){
            if ( teamType === 'heim' ) {
                this.partien[partieId].heim.bahn = partieId%2 === 0 ? 3 : 1;
                this.partien[partieId].heim.bahn += addBahnen;
            } else {
                this.partien[partieId].gast.bahn = partieId%2 === 0 ? 4 : 2;
                this.partien[partieId].gast.bahn += addBahnen;
            }
        }
    setNameAndPassNrForSelectedSpieler(i, type, spielerListe){
        let partieSpieler = this.partien[i][type].spieler;
        let spieler = spielerListe.find(spieler => spieler.id === partieSpieler.id);
        if ( !spieler ) {
            partieSpieler.name = '';
            partieSpieler.passNr = '';
            partieSpieler.nationalitaet = '';
            partieSpieler.akHJ = '';
            partieSpieler.akJahr = '';
        } else {
            partieSpieler.name = spieler.name;
            partieSpieler.passNr = spieler.passNr;
            partieSpieler.nationalitaet = '';
            partieSpieler.akHJ = spieler.akHJ;
            partieSpieler.akJahr = spieler.akJahr;
            this.setPrivateData(partieSpieler);
        }
    }
    setNameAndPassNrForSelectedErsatzSpieler(i, type, spielerListe){
        let ersatzSpieler = this[type].ersatzSpieler[i];
        let spieler = spielerListe.find(spieler => spieler.id === ersatzSpieler.id);
        if ( !spieler ) {
            ersatzSpieler.name = '';
            //ersatzSpieler.passNr = spieler.passNr;
            ersatzSpieler.nationalitaet = '';
            ersatzSpieler.akHJ = '';
            ersatzSpieler.akJahr = '';
        } else {
            ersatzSpieler.name = spieler.name;
            //ersatzSpieler.passNr = spieler.passNr;
            ersatzSpieler.nationalitaet = '';
            ersatzSpieler.akHJ = spieler.akHJ;
            ersatzSpieler.akJahr = spieler.akJahr;
            this.setPrivateData(ersatzSpieler);
        }

    }
    setPrivateData(spieler){
        if ( !spieler.id ) { return }
        db.collection("spieler/" + spieler.id + "/private" ).doc(spieler.id).get()
        .then((doc) => {
            if (doc.exists) {
                spieler.nationalitaet = doc.data().nationalitaet;
            } else {
                // doc.data() will be undefined in this case
                console.log("No such document!");
            }
        }).catch((error) => {
            console.log("Error getting document:", error);
        });
    }
// Partien
    hasEmptyDg () {
        const partien = Object.keys(this.partien).length;
        for ( let i = 1; i <= partien; i++ ) {
            let partie = this.partien[i];
            for ( let j = 1; j <= 4; j++ ) {
                const dg = 'd' + j;
                if ( partie.heim.input[dg] == 0 ) { return true }
                if ( partie.gast.input[dg] == 0 ) { return true }
            }
        }
        return false;
    }
    getSpielerListe(type){
        let list = [];
        Object.keys(this.partien).forEach( (partieId) => {
            let spieler = this.partien[partieId][type].spieler;
            spieler.partieId = partieId;
            list.push(spieler);
        });
        // Bug report mail Chris 23.1.2022 => not finally implemented because of partieId
        // notwendig damit Schnittlisten richtig gerechnet werden
        // nicht mehr notwendig, siehe Todo-Liste, item BL77
        return list;
    }
    getNrOfPartien(){
        return Object.keys(this.partien).length;
    }
    getNrOfErsatzspieler(teamType){
        return Object.keys(this[teamType].ersatzSpieler).length;
    }
    getNrOfErsatzspielerDefined(teamType){
        let i = 0;
        Object.keys(this[teamType].ersatzSpieler).forEach( (spielerId) => {
            if ( this[teamType].ersatzSpieler[spielerId].id ) {
                i++;
            }
        });
        return i;
    }
    getMaxNrOfErlaubteWechsel(){
        return Object.keys(this.partien).length < 6 ? 1 : 2;
    }
    getLigaId(){
        const saisonIdParts = this.saison.id.split('_');
        return saisonIdParts[0] + '_' + saisonIdParts[1];
    }
    getLigaData(fieldName){
        return store.state.realtime.landesverbaende[this.saison.lvId] ?
            store.state.realtime.landesverbaende[this.saison.lvId].ligen[this.getLigaId()][fieldName] : '';
    }
    getSportJahr(){
        const saisonIdParts = this.saison.id.split('_');
        return saisonIdParts[2] + '_' + saisonIdParts[3];
    }

    getDatumFormated(){
        return TimeStamp.getStringDotDateFromString(this.infos.datum)
    }

    getSubTitle(){
        let semester = this.saison.isCup ? this.saison.rundeText ? '- ' : '- Runde ' : this.saison.semester + ' '
        if ( !this.saison.rundeText ) {
            semester += this.saison.runde + ' - '
        } else {
            semester += this.saison.rundeText + ' - '
        }
        const part2 = this.infos.wochentag + '., ' +
                    this.getDatumFormated() + ', ' +
                    this.infos.uhrzeit
        return this.infos.uhrzeit ? this.getLigaData('nameFull') + ' ' + semester + part2 : '';
    }
    getAltersklasse(spieler){
        return SpielService.getAltersklasse(spieler.akHJ, spieler.akJahr, this.saison.id )
    }
// calculate partien
    calculate(){
        Object.keys(this.partien).forEach( (partieId) => {
            let partie = this.partien[partieId];
            this.resetSums(partie);
            if ( !this.saison.isCup ) {
                this.calculateSPs(partie)
                this.calculateMP(partie)
            } else {
                this.calculateCupResult(partie)
            }

        });
        this.calculateResult();
    }

    resetSums(partie){
        partie.heim.kegel = 0;
        partie.heim.sp = 0;
        partie.heim.mp = 0;
        //partie.heim.mlp = 0;
        //partie.heim.tabPkt = 0;
        partie.gast.kegel = 0;
        partie.gast.sp = 0;
        partie.gast.mp = 0;
        //partie.gast.mlp = 0;
        //partie.gast.tabPkt = 0;
        if ( this.saison.isCup ) {
            partie.heim.ar = 0;
            partie.gast.ar = 0;
        }
    }

    calculateCupResult(partie){
        for ( let i = 1; i <= 4; i++ ) {
            const dg = 'd' + i;
            const dgAr = 'ar' + i;
            partie.heim.input[dg] = partie.heim.input[dg] !== null ? parseInt(partie.heim.input[dg]) : 0;
            partie.gast.input[dg] = partie.gast.input[dg] !== null ? parseInt(partie.gast.input[dg]) : 0;
            partie.heim.inputAr[dgAr] = partie.heim.inputAr[dgAr] !== null ? parseInt(partie.heim.inputAr[dgAr]) : 0;
            partie.gast.inputAr[dgAr] = partie.gast.inputAr[dgAr] !== null ? parseInt(partie.gast.inputAr[dgAr]) : 0;
            // update sums
            partie.heim.kegel += partie.heim.input[dg] + partie.heim.inputAr[dgAr];
            partie.gast.kegel += partie.gast.input[dg] + partie.gast.inputAr[dgAr];
            partie.heim.ar += partie.heim.inputAr[dgAr];
            partie.gast.ar += partie.gast.inputAr[dgAr];
        }
    }

    calculateSPs(partie){
        for ( let i = 1; i <= 4; i++ ) {
            const dg = 'd' + i;
            const sp = 'sp' + i;
            partie.heim.input[dg] = parseInt(partie.heim.input[dg]);
            partie.gast.input[dg] = parseInt(partie.gast.input[dg]);
            if ( partie.heim.input[dg] > partie.gast.input[dg] ) {
                partie.heim[sp] = 1;
                partie.gast[sp] = 0;
            } else if ( ( partie.heim.input[dg] < partie.gast.input[dg] ) ) {
                partie.heim[sp] = 0;
                partie.gast[sp] = 1;
            } else if ( partie.heim.input[dg] > 0 && partie.gast.input[dg] > 0 ) {
                partie.heim[sp] = 0.5;
                partie.gast[sp] = 0.5;
            } else {
                partie.heim[sp] = 0;
                partie.gast[sp] = 0;
            }
        // update sums
            partie.heim.kegel += partie.heim.input[dg];
            partie.heim.sp += partie.heim[sp];
            partie.gast.kegel += partie.gast.input[dg];
            partie.gast.sp += partie.gast[sp];
        }
    }
    calculateMP(partie){
        if ( partie.heim.sp === partie.gast.sp ) {
            this.calculateMPOnKegel(partie);
        } else if ( partie.heim.sp > partie.gast.sp ) {
            partie.heim.mp = 1;
        } else {
            partie.gast.mp = 1;
        }
    }
        calculateMPOnKegel(partie){
            if ( partie.heim.kegel === partie.gast.kegel ) {
                if ( partie.heim.kegel > 0 && partie.gast.kegel > 0 ) {
                    partie.heim.mp = 0.5;
                    partie.gast.mp = 0.5;
                }
            } else if ( partie.heim.kegel > partie.gast.kegel ) {
                partie.heim.mp = 1;
            } else {
                partie.gast.mp = 1;
            }
        }
// calculate Result
    calculateResult(){
        this.resetResult(this.heim.result);
        this.resetResult(this.gast.result);
        this.calculateTeam(this.heim.result, 'heim');
        this.calculateTeam(this.gast.result, 'gast');
        this.calculateCompare();
    }
    resetResult(result){
        result.kegel = 0;
        result.mp = 0;
        result.mlp = 0;
        result.schnitt = 0;
        result.sp = 0;
        result.tabPkt = 0;
        result.fw = 0;
        if ( this.saison.isCup ) result.ar = 0;
    }
    calculateTeam(result, type){
        let partien = Object.keys(this.partien).length;
        Object.keys(this.partien).forEach( (partieId) => {
            let partie = this.partien[partieId][type];
            result.kegel += partie.kegel;
            result.sp += partie.sp;
            result.mp += partie.mp;
            result.fw += parseInt(partie.fehlwuerfe);
            if ( this.saison.isCup ) result.ar += partie.ar;
        });
        //result.schnitt = Math.round(result.kegel / partien);
        this.calculateLiveSchnitt(result, type, partien)
    }
        calculateLiveSchnitt(result, type, partien){
            if ( this.partien[partien].heim.input.d4 > 0 || this.partien[partien].gast.input.d4 > 0 ) {
            // one team is finished
                result.schnitt = parseInt( (result.kegel / partien).toFixed(2) ) ;
            } else if ( this.partien['1'].heim.input.d4 > 0 || this.partien['1'].gast.input.d4 ) {
            // one team has finished first round
                for ( let i = partien; i >= 1; i-- ) {
                    if ( this.partien[i][type].input.d1 > 0 &&
                        this.partien[i][type].input.d4 === 0 && i === 1) {
                    // only first partie and last durchgang missing
                        result.schnitt = 0;
                        return;
                    } else if ( this.partien[i][type].input.d1 > 0 &&
                         this.partien[i][type].input.d4 === 0 ) {
                    // at least second partie and last durchgang missing
                        let partieResult = 0;
                        for ( let j = 4; j >= 1; j-- ) {
                            partieResult +=this.partien[i][type].input['d'+j];
                        }
                        result.schnitt = parseInt ( ( (result.kegel - partieResult) / (i-1) ).toFixed(2) );
                        return;
                    } else if ( this.partien[i][type].input.d1 > 0 &&
                                this.partien[i][type].input.d4 > 0 ) {
                    // this partie is complete
                        result.schnitt = parseInt ( ( result.kegel / i ).toFixed(2) );
                        return
                    }
                }
            }
        }
    calculateCompare() {
        if ( this.saison.isCup ) {
            this.calculateCompareCup();
            return;
        }
    // mlp
        if ( this.heim.result.kegel > this.gast.result.kegel ) {
            this.heim.result.mlp = 2;
            this.heim.result.mp += 2;
        } else if ( this.heim.result.kegel < this.gast.result.kegel ) {
            this.gast.result.mlp = 2;
            this.gast.result.mp += 2;
        } else if ( this.heim.result.kegel > 0 && this.gast.result.kegel > 0) {
            this.heim.result.mlp = 1;
            this.heim.result.mp += 1;
            this.gast.result.mlp = 1;
            this.gast.result.mp += 1;
        }
    // tabellenpunkte
        if ( this.heim.result.mp === this.gast.result.mp && this.heim.result.mp > 0 && this.gast.result.mp > 0 ) {
            this.heim.result.tabPkt = 1;
            this.gast.result.tabPkt = 1;
        } else if ( this.heim.result.mp > this.gast.result.mp) {
            this.heim.result.tabPkt = 2;
        } else if (this.gast.result.mp > 0)  {
            this.gast.result.tabPkt = 2;
        }
    }
    calculateCompareCup(){
        if ( this.heim.result.kegel === this.gast.result.kegel ) {
            if ( this.heim.result.ar === this.gast.result.ar ) {
                if ( this.heim.result.fw === this.gast.result.fw ) {
                    const lowestTeam = this.getLowestPartieScore()
                    this.heim.result.cupLeader = lowestTeam === 'heim'
                    this.gast.result.cupLeader = lowestTeam === 'gast'
                } else if (this.heim.result.fw < this.gast.result.fw) {
                    this.heim.result.cupLeader = true
                    this.gast.result.cupLeader = false
                } else {
                    this.heim.result.cupLeader = false
                    this.gast.result.cupLeader = true
                }
            } else if (this.heim.result.ar > this.gast.result.ar) {
                this.heim.result.cupLeader = true
                this.gast.result.cupLeader = false
            } else {
                this.heim.result.cupLeader = false
                this.gast.result.cupLeader = true
            }
        } else if (this.heim.result.kegel > this.gast.result.kegel) {
            this.heim.result.cupLeader = true
            this.gast.result.cupLeader = false
        } else {
            this.heim.result.cupLeader = false
            this.gast.result.cupLeader = true
        }
    }
        getLowestPartieScore(){
            let lowestHeim = 0
            let lowestGast = 0
            Object.keys(this.partien).forEach( (partieId) => {
                const partie = this.partien[partieId]
                lowestHeim = lowestHeim === 0 || (partie.heim.kegel < lowestHeim && partie.heim.kegel > 0) ?
                                partie.heim.kegel : lowestHeim
                lowestGast = lowestGast === 0 || (partie.gast.kegel < lowestGast && partie.gast.kegel > 0) ?
                                partie.gast.kegel : lowestGast
            });
            return lowestHeim === lowestGast ? '' : lowestHeim < lowestGast ? 'heim' : 'gast'
        }

// get Data for Reports
    getKegelDelta(){
        return Math.abs(this.heim.result.kegel - this.gast.result.kegel);
    }

    getKegelDeltaSign(type){
        if ( this.heim.result.kegel === this.gast.result.kegel ) { return '';}
        let bigger = this.heim.result.kegel > this.gast.result.kegel;
        if ( type === 'heim' ) {
            return bigger ? '+' : '-'
        } else {
            return !bigger ? '+' : '-'
        }
    }

    getEintauschText(ersatzSpieler){
        if ( ersatzSpieler.eintauschFuer || ersatzSpieler.eintauschVorFuer ) {
            const spielerName = this.getSpielerNameById(
                ersatzSpieler.eintauschVorFuer ? ersatzSpieler.eintauschVorFuer : ersatzSpieler.eintauschFuer
            );
            return ersatzSpieler.eintauschVorFuer ?
                ['vor Einspielzeit für ', spielerName] :
                ['ab Wurf ', ersatzSpieler.abWurf, ' für ', spielerName]
        } else {
            return ''
        }
    }
        getSpielerNameById(spielerId){
            let result = '';
            Object.keys(this.partien).forEach( (partieId) => {
                const partie = this.partien[partieId];
                if ( partie.heim.spieler.id === spielerId ) { result = partie.heim.spieler.name }
                if ( partie.gast.spieler.id === spielerId ) { result = partie.gast.spieler.name }
            });
            return result;
        }

// get styles for reports
    getCSSColor(type, parameter, classList){
        if ( this.saison.isCup ) return this.getCSSColorCup(type, classList)
        const otherType = type === 'heim' ? 'gast' : 'heim';
        const color = this[type].result[parameter] === this[otherType].result[parameter] ?
            'blue--text text--darken-3' :
            this[type].result[parameter] > this[otherType].result[parameter] ?
                'green--text' : 'red--text';
        return [ color ].concat( classList );
    }
    getCSSColorCup(type, classList){
        const otherType = type === 'heim' ? 'gast' : 'heim';
        const color = !this[type].result.cupLeader && !this[otherType].result.cupLeader ?
            'blue--text text--darken-3' :
            this[type].result.cupLeader ? 'green--text' : 'red--text'
        return [ color ].concat( classList );
        /*
        const otherType = type === 'heim' ? 'gast' : 'heim';
        const color = this[type].result.kegel > this[otherType].result.kegel ?
            'green--text' : this[type].result.kegel < this[otherType].result.kegel ? 'red--text' :
            // abräumen
            this[type].result.ar > this[otherType].result.ar ?
            'green--text' : this[type].result.ar < this[otherType].result.ar ? 'red--text' :
            'blue--text text--darken-3';
        return [ color ].concat( classList );

         */
    }
    getTeamRekordString(type){
        let fields = ['oeR', 'bR', 'mR'];
        let texts = ['österr. Rekord', 'Bahnrekord', 'Mannschaftsrekord'];
        let result = [];
        let i = 0;
        fields.forEach( (field) => {
            if ( this[type].result[field] ) { result.push(texts[i]) }
            i++;
        });
        return result.join(', ');
    }


// Testing
    setZufallResult(){
        Object.keys(this.partien).forEach( (partieId) => {
            let partie = this.partien[partieId];
            this.setZufallSub(partie.heim.input);
            this.setZufallSub(partie.gast.input);
        });
    }
        setZufallSub(partieTeamInput){
            for ( let i = 1; i < 5; i++ ) {
                partieTeamInput['d'+i] = Math.round(Math.random() * (150 - 100) + 100);
            }
            this.calculate()
        }

    setZufallMaL(){
        this.infos.bahn = 'Gasthof Bauer';
        this.heim.captain = 'Peter Heimkapitän';
        this.gast.captain = 'Eva Gastkapitänin';
        this.referee.name = 'Susi Extrastreng';
        this.referee.nr = '123';
        this.referee.lvId = '14';
    }
    setZufallMaLTeam(spielerListe, type){
        let i = 0;
        let max = spielerListe.length-1;
        Object.keys(this.partien).forEach( (partieId) => {
            let partie = this.partien[partieId][type];
            partie.spieler = spielerListe[i];
            this.setPrivateData(partie.spieler);
            i++;
            if ( i>max ) { i=0 }
        });
    }
    setBahnen(e, partieId, type){
        console.log ("setBahnen",e,  partieId, type);
        if ( partieId === 1 && type === 'heim' ) {
            this.setDefaultBahnen(e);
        }
    }
    setBahnenFromVereinsdatenblatt(vereinsDatenBlatt) {
        if (!vereinsDatenBlatt?.sportanlage.bahnen) {
            this.setDefaultBahnen(1); return
        }
        const anzahlPartien = Object.keys(this.partien).length
        const bahnenKey = anzahlPartien === 6 ? 'sechserTeam' : 'viererTeam'
        const anzahlBahnen = vereinsDatenBlatt.sportanlage.bahnen[bahnenKey].bis -
                             vereinsDatenBlatt.sportanlage.bahnen[bahnenKey].von + 1
        if ( anzahlBahnen === 4 ) {
            this.setDefaultBahnen(vereinsDatenBlatt.sportanlage.bahnen[bahnenKey].von);
        } else if ( anzahlBahnen === 6 ) {
            this.setSechsBahnen(vereinsDatenBlatt);
        } else {
            this.setDefaultBahnen(1);
        }
    }
        setSechsBahnen(vereinsDatenBlatt){
            const start = vereinsDatenBlatt.sportanlage.bahnen.sechserTeam.von
            this.partien[1].heim.bahn = start;
            this.partien[2].heim.bahn = start+2;
            this.partien[3].heim.bahn = start+4;
            this.partien[4].heim.bahn = start;
            this.partien[5].heim.bahn = start+2;
            this.partien[6].heim.bahn = start+4;
            const startGast = vereinsDatenBlatt.sportanlage.bahnen.sechserTeam.von + 1
            this.partien[1].gast.bahn = startGast;
            this.partien[2].gast.bahn = startGast+2;
            this.partien[3].gast.bahn = startGast+4;
            this.partien[4].gast.bahn = startGast;
            this.partien[5].gast.bahn = startGast+2;
            this.partien[6].gast.bahn = startGast+4;
        }

// change verification
    spielBerichtHasChanged(previousData){
        return JSON.stringify(this.partien) !== JSON.stringify(previousData.partien) ||
            JSON.stringify(this.gast.ersatzSpieler) !== JSON.stringify(previousData.gast.ersatzSpieler) ||
            JSON.stringify(this.heim.ersatzSpieler) !== JSON.stringify(previousData.heim.ersatzSpieler) ||
            JSON.stringify(this.gast.result) !== JSON.stringify(previousData.gast.result) ||
            JSON.stringify(this.heim.result) !== JSON.stringify(previousData.heim.result) ||
            this.infos.kommentar !== previousData.infos.kommentar ||
            this.infos.kommentarStrafe !== previousData.infos.kommentarStrafe ||
            this.gast.protest !== previousData.gast.protest ||
            this.heim.protest !== previousData.heim.protest;
    }
}